import * as React from 'react'
import {connect} from 'react-redux'
import type {OmitStrict} from 'type-zoo'
import api from '~/api/endpoints'
import type GameData from '~/models/game/GameData'
import type {IPlayerPortfolioUIProps} from '~/pages/GameLobby/GameBoard/Portfolio/stateless'
import PlayerPortfolioUI from '~/pages/GameLobby/GameBoard/Portfolio/stateless'
import type {ReduxState} from '~/redux/reducers/root'
import {setSpectatorData} from '~/redux/reducers/spectator'

interface IReduxProps extends Pick<ReduxState, 'spectatorState'> {}
interface IProps
  extends
    IReduxProps,
    TDispatch,
    OmitStrict<
      IPlayerPortfolioUIProps,
      | 'spectatorData'
      | 'requestSpectatorPermission'
      | 'gameId'
      | 'currentGamePosition'
      | 'currentPlayerId'
    > {
  gameData: GameData
}

class PlayerPortfolio extends React.Component<IProps> {
  render() {
    const {
      gameData,
      spectatorState,
      setSpectatorData: createSetSpectatorAction,
      ...uiProps
    } = this.props
    return (
      <PlayerPortfolioUI
        gameId={gameData.gameId}
        currentGamePosition={gameData.currentGamePosition}
        spectatorData={spectatorState.spectatorData}
        currentPlayerId={gameData.currentPlayerId}
        requestSpectatorPermission={() => {
          void api.inGame.requestSpectatorPermission
            .execute(
              {},
              {gameId: gameData.gameId, spectatedPlayerId: uiProps.player.id}
            )
            .then(r => {
              createSetSpectatorAction(r.spectatorRequests)
            })
        }}
        {...uiProps}
      />
    )
  }
}

const mapStateToProps = (state: ReduxState): IReduxProps => ({
  spectatorState: state.spectatorState,
})

const mapDispatchToProps = {setSpectatorData}
type TDispatch = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(PlayerPortfolio)
